import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import { __awaiter, __generator } from "tslib";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
import store from '@/store';
export default [
/** 战队详情部分 */
{
  path: '/team/detail/normal/:teamId/:activitySpecialId?',
  alias: '/team/detail/share/:activityId/:teamId/:activitySpecialId?',
  name: ROUTE_NAME.TEAM_DETAIL_NORMAL,
  meta: {
    title: '战队详情',
    popup: 'market',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0
  },
  component: function component() {
    return import(
    /* webpackChunkName: "team" */
    '@/pages/team/detail/normal.vue');
  }
}, {
  path: '/team/detail/home/:teamId',
  // alias: '/team/detail/share/:activityId/:teamId',
  name: ROUTE_NAME.TEAM_DETAIL_HOME,
  meta: {
    title: '战队详情',
    popup: 'market',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0
  },
  component: function component() {
    return import(
    /* webpackChunkName: "team" */
    '@/pages/team/detail/home.vue');
  }
}, {
  path: '/team/detail/stat/:activityId/:teamId/:activitySpecialId?',
  name: ROUTE_NAME.TEAM_DETAIL_STAT,
  meta: {
    title: '数据统计',
    popup: 'market',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0
  },
  component: function component() {
    return import(
    /* webpackChunkName: "team" */
    '@/pages/team/detail/stat.vue');
  }
}, {
  path: '/team/detail/rank/:teamId',
  name: ROUTE_NAME.TEAM_DETAIL_RANK,
  meta: {
    title: '排行榜',
    scrollBehavior: 'top'
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "team" */
      '@/pages/team/detail/rank.vue'),
      loading: Loading
    };
  }
}, {
  path: '/team/invite_card/:activityId/:teamId?',
  name: ROUTE_NAME.TEAM_INVITE_CARD,
  meta: {
    title: '邀请卡',
    scrollBehavior: 'top',
    needLogin: true,
    needLoginNext: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "team" */
      '@/pages/team/inviteCard.vue'),
      loading: Loading
    };
  }
}, // 根据用户报名信息进行跳转
{
  path: '/team/invite_card_enter/:activityId/:userId',
  beforeEnter: function beforeEnter(to, from, next) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, activityId, userId, rdata, teamId;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = to.params, activityId = _a.activityId, userId = _a.userId;
            store.commit('startRequest');
            return [4
            /*yield*/
            , store.dispatch('activity/getUserParticipation', {
              activityId: activityId,
              userId: userId
            })];

          case 1:
            rdata = _b.sent();
            store.commit('endRequest'); // 已经报名

            if (rdata.status === 0) {
              teamId = rdata.data;

              if (teamId) {
                // 已经报名
                next({
                  name: ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
                  params: {
                    activityId: activityId,
                    teamId: teamId,
                    type: 'pay'
                  },
                  query: {
                    referrer_id: userId
                  }
                });
              } else {
                next({
                  name: ROUTE_NAME.ACTIVITY,
                  params: {
                    activityId: activityId
                  }
                });
              }
            } else {
              next(false);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  }
}, // 只根据team数据来跳转
{
  path: '/team/invite_card_enter/:teamId?',
  beforeEnter: function beforeEnter(to, from, next) {
    return __awaiter(this, void 0, void 0, function () {
      var teamId, teamDetail;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            teamId = to.params.teamId;
            if (!teamId) return [3
            /*break*/
            , 2];

            if (Number(teamId) < 5) {
              next(false);
              return [2
              /*return*/
              ];
            }

            store.commit('startRequest');
            return [4
            /*yield*/
            , store.dispatch('activity/getTeamDetail', {
              teamId: teamId
            })];

          case 1:
            _a.sent();

            store.commit('endRequest');
            teamDetail = store.state.activity.team.detail[Number(teamId)];

            if (teamDetail) {
              next({
                name: ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
                params: {
                  activityId: teamDetail.activity_id,
                  teamId: teamId,
                  type: 'pay'
                }
              });
              return [2
              /*return*/
              ];
            }

            _a.label = 2;

          case 2:
            // 没有teamId的时候，跳转到当前正在进行中的活动
            next({
              name: ROUTE_NAME.ACTIVITY,
              params: {
                activityId: store.getters['activity/activityId']
              }
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  }
}, {
  path: '/team/detail/members/:activityId/:teamId?',
  name: ROUTE_NAME.TEAM_DETAIL_MEMBERS,
  meta: {
    title: '战队成员',
    scrollBehavior: 'restore',
    scorllDefaultPosition: 0
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "team" */
      '@/pages/team/detail/members.vue'),
      loading: Loading
    };
  }
}, {
  path: '/team/identification/:activityId',
  name: ROUTE_NAME.TEAM_IDENTIFICATION,
  meta: {
    title: '队旗申请',
    scrollBehavior: 'top',
    scorllDefaultPosition: 0,
    disableShare: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "team" */
      '@/pages/team/identification.vue'),
      loading: Loading
    };
  }
}];